import {atom} from "jotai";
import type {WorkloadScanResult} from "./scan-operations/performWorkloadScan.ts";
import {CustomerAnalysisOptionsDep} from "../1-options/CustomerAnalysisOptions.ts";

export const WorkloadScanAtom = atom<WorkloadScanResult | undefined>(undefined)

// Clear scan result when options change
CustomerAnalysisOptionsDep((set) => {
    set(WorkloadScanAtom, undefined)
})
